import axios from 'axios';
import api_url from '../urls';
const actions = {

  async getInfoGrade (context, value) {
   
        context.commit('SET_INFO_GRADE', value)
  
  },
 
  async  getDisciplinaGrade (context,value) {

      const USER_TOKEN = localStorage.getItem('access_token');
      const AuthStr = 'Bearer '.concat(USER_TOKEN)
    await   axios.get(api_url.api_admin + 'listaMateriasGrade/'+value.id,
    {
        headers: {
            'authorization': AuthStr,
            'Accept' : 'application/json',
            'Content-Type': 'application/json'
        }
    })
    .then(response => {
        console.log(response.data);
        context.commit('SET_DISCIPLINA_GRADE', response.data)
    })
    .catch((error) => {
        console.log(error);
    });
    
  },
}

export default actions